import { PlusOutlined, UserOutlined } from "@ant-design/icons";
import { useQuery } from "@tanstack/react-query";
import { Avatar, Button, Select } from "antd";
import { FC, useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { useSelector } from "react-redux";
import { getClients } from "../../../../network/clients";
import { client } from "../../../../types/calendar";
import AddClientForm from "./AddClientForm";
interface AddClientProps {
  // clientId: number | null;
  // setClientId: React.Dispatch<React.SetStateAction<number | null>>;
  clientData?: any;
  setClientData: React.Dispatch<any>;
}
export const addSVG = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="#000000"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.5 2H4.5C3.8372 2.00079 3.20178 2.26444 2.73311 2.73311C2.26444 3.20178 2.00079 3.8372 2 4.5L2 15.5C2.00079 16.1628 2.26444 16.7982 2.73311 17.2669C3.20178 17.7356 3.8372 17.9992 4.5 18H15.5C16.1628 17.9992 16.7982 17.7356 17.2669 17.2669C17.7356 16.7982 17.9992 16.1628 18 15.5V4.5C17.9992 3.8372 17.7356 3.20178 17.2669 2.73311C16.7982 2.26444 16.1628 2.00079 15.5 2ZM17 15.5C17 15.8978 16.842 16.2794 16.5607 16.5607C16.2794 16.842 15.8978 17 15.5 17H4.5C4.10218 17 3.72064 16.842 3.43934 16.5607C3.15804 16.2794 3 15.8978 3 15.5V4.5C3 4.10218 3.15804 3.72064 3.43934 3.43934C3.72064 3.15804 4.10218 3 4.5 3H15.5C15.8978 3 16.2794 3.15804 16.5607 3.43934C16.842 3.72064 17 4.10218 17 4.5V15.5Z"
      fill="#00086D"
    />
    <path
      d="M10.3307 6.92285H9.66406V9.92285H6.66406V10.5895H9.66406V13.5895H10.3307V10.5895H13.3307V9.92285H10.3307V6.92285Z"
      fill="#00086D"
    />
  </svg>
);
const AddClient: FC<AddClientProps> = ({ clientData, setClientData }) => {
  const intl = useIntl();
  const { currentLang } = useSelector(
    (state: { user: { currentLang: "en" | "ar" } }) => state.user
  );
  const [showClientForm, setShowClientForm] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const { data, isLoading, isSuccess, refetch } = useQuery(
    ["clients", searchValue],
    () => getClients(searchValue)
  );
  const [selectedClient, setSelectedClient] = useState<client | null>(null);

  const clients = Array.isArray(data?.data?.data)
    ? data?.data?.data?.map((client: client) => {
        return {
          id: client?.id,
          value: client?.id,
          first_name: client?.first_name,
          last_name: client?.last_name,
          label: client?.first_name + " " + client?.last_name,
          // avatar: client?.avatar,
          // createdAt: client?.created_at
        };
      })
    : [];

  useEffect(() => {
    if (clientData?.id) {
      const existedClient =
        Array.isArray(data?.data?.data) &&
        data?.data?.data.find((item: client) => item?.id === clientData?.id);
      if (existedClient) {
        setSelectedClient(existedClient);
        setClientData(existedClient);
      }
    }
  }, [clientData, data]);
  console.log("clientData", clientData);
  return (
    <div className="w-full">
      {showClientForm ? (
        <div>
          <AddClientForm
            refetch={refetch}
            setShowClientForm={setShowClientForm}
            setClientData={setClientData}
          />
        </div>
      ) : (
        <div>
          {selectedClient ? (
            <Button
              type="text"
              htmlType="button"
              onClick={() => {
                setSelectedClient(null);
                setClientData(null);
              }}
              className="w-full bg-[#EEF0FF] h-16 rounded-lg"
            >
              <div className="flex items-center justify-between gap-2 text-sm md:text-base  w-full">
                <div className="flex items-center gap-1">
                  <span>
                    <Avatar
                      src={"selectedClient?.avatar"}
                      size={35}
                      icon={<UserOutlined />}
                    >
                      {selectedClient?.first_name?.charAt(0).toUpperCase() +
                        selectedClient?.last_name?.charAt(0).toUpperCase()}
                    </Avatar>
                  </span>
                  <span>
                    {selectedClient?.first_name +
                      " " +
                      selectedClient?.last_name}
                  </span>
                </div>
                <div className="flex items-center gap-1">
                  <span className="text-gray-500">
                    {intl.formatMessage({
                      id: "clientSince",
                    })}
                    :
                  </span>
                  <span>
                    {new Date(selectedClient?.created_at).toLocaleString(
                      currentLang === "ar" ? "ar" : "en",
                      {
                        month: "long",
                      }
                    )}{" "}
                    {new Date(selectedClient?.created_at).getFullYear()}
                  </span>
                </div>
              </div>
            </Button>
          ) : (
            <div className="flex items-center justify-center gap-1">
              <Select
                className="w-full"
                value={clientData?.id}
                onSearch={(value) => {
                  setSearchValue(value);
                }}
                onChange={(value) => {
                  const client: client = data?.data?.data.find(
                    (client: client) => client?.id === value
                  );

                  if (!client) return;

                  setSelectedClient(client);
                  setClientData(client);
                  if (clientData) {
                    clientData(client);
                  }
                  setSearchValue("");
                }}
                showSearch
                placeholder={intl.formatMessage({
                  id: "selectClient",
                  defaultMessage: "ابحث عن عميل",
                })}
                // suffixIcon={<div className="">asds</div>}
                prefixCls="asd"
                optionFilterProp="children"
                filterOption={(input, option) =>
                  (option?.first_name ?? "").includes(input)
                }
                filterSort={(optionA, optionB) =>
                  (optionA?.first_name ?? "")
                    .toLowerCase()
                    .localeCompare((optionB?.first_name ?? "").toLowerCase())
                }
                options={clients}
              />
              <Button
                type="link"
                htmlType="button"
                className="flex items-center justify-center w-10 p-0"
                onClick={() => {
                  setShowClientForm(true);
                }}
              >
                <PlusOutlined
                  style={{ border: "solid 2px #00086D" }}
                  className="flex items-center justify-center p-2 font-semibold rounded-md text-color-primary"
                />
              </Button>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default AddClient;
